import { Component, OnInit, Inject } from '@angular/core';
import { NoMedicalFeeReasonFilter } from 'src/app/model/medical-fee';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterService } from '../../../services/filter.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-no-medical-fee-reason-dialog',
  templateUrl: './no-medical-fee-reason-dialog.component.html',
  styleUrls: ['./no-medical-fee-reason-dialog.component.css']
})
export class NoMedicalFeeReasonDialogComponent  implements OnInit {

  form: FormGroup;
  noMedicalFeeReasons: NoMedicalFeeReasonFilter[] = [];

  constructor(
    public dialogRef: MatDialogRef<NoMedicalFeeReasonDialogComponent>,
    private filterService: FilterService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      observations: [''],
      noMedicalFeeReason: [null, Validators.required]
    });
  }

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.dialogRef.close(<NoMedicalFeeDialogResponse>this.form.getRawValue());
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'No liquidar motivos');
    }
  }

  async ngOnInit() {
    try {
      this.noMedicalFeeReasons
       = await this.filterService.getNoMedicalFeeReasonFilters();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'No liquidar motivos');
    }
  }
}


export class NoMedicalFeeDialogResponse {
  noMedicalFeeReason: NoMedicalFeeReasonFilter;
  observations: string;
}
